import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';
import { setPreselectedLandingZone } from '@rsos/reduxDataStore/src/features/airAmbulance/airAmbulanceSlice';
import {
  openResourcePanel,
  setResourcePanelView,
  setSelectedRequest,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import {
  trackOpenAirAmbulanceRequestForm,
  AIR_AMBULANCE_FORM_SOURCE,
} from '../../../../../gainsightTrackings/airAmbulanceTrackings';
import LocationSummary, {
  StyledLocationSummary,
} from '../../../../Map/MapCard/LocationSummary';

const LocationContainer = styled(Box)`
  ${StyledLocationSummary} {
    margin-bottom: 0;
  }
`;

const ButtonContainer = styled(Box)`
  border: ${({ isFromMap, theme }) =>
    !isFromMap && `1px solid ${theme.colors.heavyLineOutline};}`}
  margin: ${({ isFromMap }) => !isFromMap && '11px 0'};
  padding: ${({ isFromMap }) => !isFromMap && '13px'};
`;

const useSpatialObject = () => {
  return useSelector(state => {
    return state.mapCard.mapCardData.spatialObject;
  });
};

const AirAmbulanceButton = props => {
  const dispatch = useDispatch();
  const spatialObject = useSpatialObject();
  const [isLoading, setIsLoading] = useState(false);
  const isFromMap = !props?.data?.spatial_object_id; // It's from the map if this data is falsy

  const handleRequestAirAmbulance = () => {
    setIsLoading(true);
    try {
      dispatch(setPreselectedLandingZone(spatialObject));

      trackOpenAirAmbulanceRequestForm({
        source: AIR_AMBULANCE_FORM_SOURCE.LANDING_ZONE_MAP_MARKER,
        landingZoneName: spatialObject?.name,
        landingZoneId: spatialObject?.id,
      });

      dispatch(setSelectedRequest(null));
      dispatch(openResourcePanel());
      dispatch(setResourcePanelView('air_ambulance'));
    } finally {
      setIsLoading(false);
    }
  };

  const address = spatialObject?.attributes?.address;
  const coordinates = {
    lat: spatialObject?.center?.coordinates[1],
    lng: spatialObject?.center?.coordinates[0],
  };

  return (
    <>
      <LocationContainer
        px="12px"
        isFromMap={isFromMap}
        className="LocationContainer"
      >
        {!isFromMap && (
          <LocationSummary
            location={address}
            coordinates={coordinates}
            overridden
          />
        )}
      </LocationContainer>

      <Box justify="center" px="13px">
        <ButtonContainer isFromMap={isFromMap}>
          <Button onClick={handleRequestAirAmbulance} disabled={isLoading}>
            {props.schema.componentProperties.properties.actionText}
          </Button>
        </ButtonContainer>
      </Box>
    </>
  );
};

export default AirAmbulanceButton;
